module.exports = __webpack_public_path__ + "static/media/landing_customer_carousel_3.eca71563.svg";